// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Hgh0","paramInput":"JobSimulator_paramInput__1uECJ","input":"JobSimulator_input__22-1n"};